<template>
  <p ref="clip-text" class="clip-text">
    <span ref="content" class="clip-text__content" :class="{ 'clip-text__content--visible' : isVisible }">
      <slot />
    </span>
  </p>
</template>

<script>
export default {
  name: 'ClipText',
  props: {
    isVisible: Boolean
  },
  mounted () {
    // this.$refs['clip-text'].style.height = this.$refs.content.getBoundingClientRect().height + 'px'
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.clip-text
  @apply relative overflow-hidden
  &__content
    @apply inline-flex translate-y-100
    transition: transform .5s
    &--visible
      @apply translate-y-0
  &--inline
    @apply inline-block
</style>
